import { useMemo } from "react";
import {
  cancelChannelAiMappingJob,
  getActiveChannelAiMappingJob,
  getChannelAiMappingJob,
  getLatestChannelAiMapping,
  startChannelAiMappingJob,
} from "../api/client";

export function useChannelAiMapping() {
  return useMemo(
    () => ({
      start: startChannelAiMappingJob,
      getJob: getChannelAiMappingJob,
      getActive: getActiveChannelAiMappingJob,
      getLatest: getLatestChannelAiMapping,
      cancel: cancelChannelAiMappingJob,
    }),
    []
  );
}
